import { CodeBook, ExportTypeEnum, PagedResult } from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils";

import { GenderEnum } from "../../models/Shared";

const apiUrlPrefix: string = "person";

export const getNationalityList = async (gender?: GenderEnum) => {
    return api.get(
        gender ? `${apiUrlPrefix}/nationalities/${gender}` : `${apiUrlPrefix}/nationalities`
    ) as Promise<CodeBook[]>
}

export const getNationalMinorityList = async () => {
    return api.get(
        `${apiUrlPrefix}/national-minorities`
    ) as Promise<CodeBook[]>
}

export const getCitizenshipList = async () => {
    return api.get(
        `${apiUrlPrefix}/citizenships`
    ) as Promise<CodeBook[]>
}

export const getGenderList = async () => {
    return api.get(
        `${apiUrlPrefix}/genders`
    ) as Promise<CodeBook[]>
}

export const getAlternativeCodeReasonList = async () => {
    return api.get(
        `${apiUrlPrefix}/alternative-code-reasons`
    ) as Promise<CodeBook[]>
}

export const getAlternativeCodeTypeList = async () => {
    return api.get(
        `${apiUrlPrefix}/alternative-code-types`
    ) as Promise<CodeBook[]>
}

export const getParentshipTypeList = async () => {
    return api.get(
        `${apiUrlPrefix}/parentship-types`
    ) as Promise<CodeBook[]>
}

export const getParentNumberList = async () => {
    return api.get(
        `${apiUrlPrefix}/parentnumbers`
    ) as Promise<CodeBook[]>
}

export const getProfessionalQualificationList = async () => {
    return api.get(
        `${apiUrlPrefix}/professional-qualifications`
    ) as Promise<CodeBook[]>
}

export const getContactMethodList = async () => {
    return api.get(
        `${apiUrlPrefix}/contact-methods`
    ) as Promise<CodeBook[]>
}
